'use client';

import Link from 'next/link';
import { SupportedLanguage, LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from '@/lib/recipe-types';

interface LanguageSwitcherProps {
  currentLang: SupportedLanguage;
  slug: string;
  category: 'eats' | 'diary' | 'play' | 'teach';
}

export function LanguageSwitcher({ currentLang, slug, category }: LanguageSwitcherProps) {
  return (
    <div
      role="navigation"
      aria-label="Language selector"
      style={{
        display: 'flex',
        gap: '0.5rem',
        flexWrap: 'wrap',
      }}
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = lang === currentLang;
        
        return (
          <Link
            key={lang}
            href={`/${lang}/blogs/${category}/${slug}`}
            aria-label={`Switch to ${LANGUAGE_NAMES[lang]}`}
            aria-current={isActive ? 'page' : undefined}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              background: isActive ? '#D97706' : 'white',
              color: isActive ? 'white' : '#D97706',
              border: '2px solid #D97706',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '0.875rem',
              transition: 'all 0.2s',
              display: 'inline-block',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = '#FFF5EB';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'white';
              }
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = '2px solid #D97706';
              e.currentTarget.style.outlineOffset = '2px';
            }}
            onBlur={(e) => {
              e.currentTarget.style.outline = 'none';
            }}
          >
            {lang.toUpperCase()}
          </Link>
        );
      })}
    </div>
  );
}

